import { ThunkDispatch } from '@reduxjs/toolkit';
import { FormikProps } from 'formik';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { Action } from 'redux';
import { ITEMS } from 'Routes/constants';
import { RootState } from 'slices';
import {
  resetProduct,
  setShowAllValidateErrors,
  setCountSubmit,
} from 'slices/product/form/reducer';
import { ProductFormDetailsInterface } from 'types/productTypes';

const FormActionButtons = ({
  dispatch,
  formik,
}: {
  dispatch: ThunkDispatch<RootState, void, Action>;
  formik: FormikProps<ProductFormDetailsInterface>;
}) => {
  const history = useNavigate();
  return (
    // <Row className="justify-content-center">
    //   <Col xs={12} sm={12} className="text-center">
    <Row>
      <Col xs={12} sm={6} className="text-center">
        <div className="mb-3">
          <Row>
            <Col xs={1} sm={3}></Col>
            <Col xs={5} sm={3}>
              <Button
                // className="btn me-2"
                // style={{
                //   backgroundColor: '#dbdbdb',
                //   border: '1px solid #ababab',
                // }}
                block
                outline
                color="dark"
                className="btn btn-ghost-light material-shadow-none"
                type="button"
                onClick={() => {
                  // alert('📢ยกเลิก ❌');
                  dispatch(resetProduct());
                  dispatch(setShowAllValidateErrors(false));
                  history(ITEMS.LIST);
                }}
              >
                {t('Btn_Cancel')}
              </Button>
            </Col>

            <Col xs={5} sm={3}>
              <Button
                // style={{
                //   backgroundColor: '#a1b900',
                //   border: '1px solid  #869a00',
                // }}
                block
                color="success"
                type="submit"
                disabled={formik.isSubmitting}
                onClick={() => {
                  dispatch(setShowAllValidateErrors(true));
                  dispatch(setCountSubmit());
                }}
              >
                {t('Btn_Save')}
              </Button>
            </Col>
            <Col xs={1} sm={3}></Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FormActionButtons;
